export const nodes = {
  downtimeList: "DOWNTIME_LIST",
};

export const dropDownOptionLabels = {
  //tranctions
  pg: "Payment Gateway",
  button: "Buttons",
  paymentLink: "Payment Links",
  sirecurring: "SI-Transaction",
  sist: "SI-Registration",
  payHandle: "Payment Handle",
  itemizedInvoice: "Invoice",
  event: "Events",
  webstore: "Web Stores",
  pos: "POS",
  storefront: "StoreFront QR",

  captured: "Success",
  in_progress: "In Progress",
  "in progress": "In Progress",
  userCancelled: "User Cancelled",
  failed: "Failed",
  autoRefund: "Auto Refund",
  "dropped" : "User Dropped",
  "bounced": "Bounced",
  "initiated": "Initiated",

  CC: "Credit Card",
  DC: "Debit Card",
  NB: "Netbanking",
  EMI: "EMI",
  CASH: "Cash",
  COD: "COD",
  UPI: "UPI",
  CHALLANPAYMENTS: "Challan Payments",
  PAYPAL: "Paypal",
  LAZYPAY: "LazyPay",
  SBQR: "Static QR",
  ISBQR: "Integrated Static QR",
  DBQR: "Merchant Dynamic QR",
  ADHR: "Aadhaar Pay",
  QR: "PayU Dynamic QR",
  OFUPI: "Intent Link",
  DBT: "InstaPayments",
  NEFTRTGS: "NEFT/RTGS",
  SPLITPAY: "Split Pay",


  ivr: "Initiated by IVR",
  emailInvoice: "Email Invoice",
  uniqTxn: "Unique Transactions",
  remReattempts: "Remove re-attempts",
  txnOffer: "Transactions with Offer",
  domTxn: "Domestic Transactions",
  interTxn: "International Transactions",
  mobile: "Mobile",
  web: "Web",
  chargebackTxn: "Chargeback Transactions",
  subEMI: "Subvention EMI",
  siInvoice: "SI Invoice",
  tpv: "Account verification transactions (TPV)",


  //buttons
  pay_now: "Pay Now",
  donate_now: "Donate Now",
  buy_now: "Buy Now",
  book_now: "Book Now",

  //refunds
  pending: "Pending",
  success: "Success",
  failure: "Failure",
  requested: "Requested",
  queued: "Queued",

  //bulkRefund
  uploaded: "Uploaded",
  processed: "Processed",
  //processing: "Processing",
  created: "Created",
  queued: "Queued",
  completed: "Completed",


  // refundBatchDetails
  // queued
  // requested
  // failure
  // in progress
  // success


  //linka
  active: "Active",
  inactive: "Deactivated",
  expired: "Expired",
  PROCESSED: "Processed",
  PROCESSING: "Processing",
  FAILED: "Failed",
  SUCCESS: "Success",
  INITIATED: "In Progress",

  //settlements
  hold: "On Hold",
  inprogress: "In Progress",
  settlementSuccess: "Settled",
  processing: "Processing",

  //onHoldSettlement
  needsResponse: "Needs response",
  rejected: "Rejected by bank",
  dueDateExpired: "Due date expired",

  //prioritysettlements
  instant: "Priority Settlement",
  normal: "Regular Settlement",

  IN_PROGRESS: "In Progress",
  REVERSED: "Reversed",
  PENDING: "Pending",
  QUEUED: "Queued",
  WAITING_FOR_RETRY: "Waiting For Retry",
  upi: "UPI",
  neft: "NEFT",
  rtgs: "RTGS",
  imps: "IMPS",

  //invoices
  draft: "Draft",
  deactivated: "Deactivated",

  //offers 
  offerAvailed: "Offer Availed"
};

export const dropDownTypeLabels = {
  paymentSource: "Source",
  status: "Transaction Status",
  offerStatus: "Offer Status",
  storefront: "Storefront",
  mode: "Payment Mode",
  buttonType: "Button Type",
  refundStatus: "Status",
  linkStatus: "Status",
  bulkStatus: "Status",
  transactionStatus: "Status",
  settlementStatus: "Status",
  settlementCycle: "Settlement Cycle",
  transferMode: "Transfer Mode",
  transferStatus: "Status",
  invoiceStatus: "Status",
  linkTxnStatus: "Transactions Status",
  moreFilters: "More Filters"
};

export const dropDownOptions = {
  //isSearchEnabled and enableShowMore only works with Drawer Filter
  [nodes.summary]: [],
  [nodes.transaction]: [
    {
      isSearchEnabled: false,
      type: "paymentSource",
      options: [
        "pg",
        "button",
        "paymentLink",
        "sirecurring",
        "sist",
        "payHandle",
        "itemizedInvoice",
        "event",
        "webstore",
        "pos",
        "storefront",
      ],
    },
    {
      isSearchEnabled: false,
      type: "status",
      options: [
        "captured",
        "in progress",
        "userCancelled",
        "failed",
        "autoRefund",
        "dropped",
        "bounced",
      ],
    },
    {
      type: "mode",
      options: [
        "CC",
        "DC",
        "NB",
        "EMI",
        "CASH",
        "COD",
        "UPI",
        "CHALLANPAYMENTS",
        "PAYPAL",
        "LAZYPAY",
        "SBQR",
        "ISBQR",
        "DBQR",
        "ADHR",
        "QR",
        "OFUPI",
        "DBT",
        "NEFTRTGS",
        "SPLITPAY"
      ],
      isSearchEnabled: false,
      enableShowMore: false,
    },
    {
      type: "moreFilters",
      options: [
          "ivr",
          "emailInvoice",
          "uniqTxn",
          "remReattempts",
          "txnOffer",
          "domTxn",
          "interTxn",
          "mobile",
          "web",
          "chargebackTxn",
          "subEMI",
          "siInvoice",
          "tpv",
      ],
      isSearchEnabled: false,
      enableShowMore: false,
    }
  ],
  [nodes.downtimeList]: [
    {
      type: "settlementStatus",
      options: ["settlementSuccess", "processing", "inprogress", "hold"],
    },
    {
      type: "settlementCycle",
      options: ["instant", "normal"],
    },
  ],
};
export const downloadRestrictOptions = {
  MAX_DOWNLOAD_RANGE: 90,
}


export const ColumnLayout = {
  singleColumn: {
    colSpan : 1,
    mColSpan : 1,
    tColSpan : 1,
    dColSpan : 1
  },

  threeColumn: {
    colSpan : 3,
    mColSpan : 2,
    tColSpan : 3,
    dColSpan : 3
  }
}


export const FilterOptionGridContainerLayout = {
  singleColumn: {
    "cols": 1,
    "mCols": 1,
    "tCols": 1,
    "dCols": 1,
    "gap": 0,
    "mGap": 0,
    "tGap": 0,
    "dGap": 0
  },

  threeColumn: {
    "cols": 2,
    "mCols": 2,
    "tCols": 3,
    "dCols": 6,
    "gap": 0,
    "mGap": 0,
    "tGap": 0,
    "dGap": 0
  }
}